import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "field__group" }
const _hoisted_2 = { class: "field__title" }
const _hoisted_3 = ["required", "type", "name", "value"]
const _hoisted_4 = { class: "radio__text" }

import { reactive, ref, Ref } from "vue";
import { TInputType } from "@/types";

interface IProps {
  name: string;
  type?: TInputType;
  value: string | number;
  options?: { key: string; name: string | "" }[];
  required?: boolean;
  validations?: string[] | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppRadio',
  props: {
    name: null,
    type: null,
    value: null,
    options: null,
    required: { type: Boolean },
    validations: null
  },
  emits: ["dataChange"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "dataChange", value: string | number, name: string | ""): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  name: string;
  type?: TInputType;
  value: string | number;
  options?: { key: string; name: string | "" }[];
  required?: boolean;
  validations?: string[] | null;
}



const dataValue: Ref<string | number> = ref(props.value);



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("fieldset", _hoisted_1, [
    _createElementVNode("legend", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
      return (_openBlock(), _createElementBlock("label", {
        key: option.key,
        class: "radio"
      }, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dataValue).value = $event)),
          required: __props.required,
          type: __props.type,
          name: __props.name,
          value: option.key,
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('dataChange', dataValue.value, __props.name))),
          class: "radio__input"
        }, null, 40, _hoisted_3), [
          [_vModelDynamic, dataValue.value]
        ]),
        _createElementVNode("span", _hoisted_4, _toDisplayString(option.name ?? option.key), 1)
      ]))
    }), 128))
  ]))
}
}

})